<div
  class="w-100 h-100 d-flex flex-column py-2 px-2"
>
  <div class="d-flex align-items-center justify-content-between mb-2 w-100">
    <div class="fw-bold text-truncate flex-grow-1">
      {{ widgetData.title }}
    </div>
    <i class="bi bi-arrows-fullscreen text-primary" style="cursor: move;"></i>
  </div>
  <ul class="nav justify-content-center mb-2 custom-tabs">
    @for (tab of tabs; track $index; let idx = $index) {
    <li class="nav-item">
      <button
        class="nav-link custom-tab"
        [class.active]="widgetData.selectedTabIndex === idx"
        (click)="selectTab(idx)"
      >
        {{ tab.label }}
        @if (tab.totalItems) {
        <span class="badge bg-secondary ms-1">{{ tab.totalItems }}</span>
        }
      </button>
    </li>
    }
  </ul>
  @if (selectedTab?.data?.length) {
  <div class="d-flex justify-content-end align-items-center gap-2 mb-3">
    <span class="text-muted small fw-semibold">
      {{ selectedTab?.totalItems || selectedTab?.data?.length || 0 }} Résultat(s)
    </span>
  </div>
  <div style="width: 100%; overflow-x: auto">
    <app-generic-table
      [columns]="selectedTab?.columns || []"
      [data]="selectedTab?.data || []"
    ></app-generic-table>
  </div>
  } @else {
  <div class="text-muted text-center flex-grow-1 d-flex align-items-center justify-content-center">
    <div>
      <i class="fas fa-tasks fa-2x mb-2"></i>
      <div>Aucune tâche à afficher</div>
    </div>
  </div>
  }
</div>
